import {
  getImageBase64,
  getBackground
  , getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
  pathToBase64,
  isColor
} from '@/utils'


const nodule = async (data) => {
  const node = data.node;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);

  const background = await getBackground(data?.customTheme)
  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "VloqcIozBP",
        width: 369.72211286089237,
        height: 369.72211286089237,
        left: -167.00090223097112,
        top: 487.97391732283467,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "G7WFpWXo-m",
        width: 369.72211286089237,
        height: 369.72211286089237,
        left: 723.8268536745406,
        top: -279.8934547244094,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "64LO-S4tde",
        width: 52.340141076115486,
        height: 52.340141076115486,
        left: 63.92642716535433,
        top: 143.94225721784775,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        opacity: 0.2,
      },
      {
        type: "shape",
        id: "x7jRgdA-fK",
        width: 30.236384514435695,
        height: 30.236384514435695,
        left: 74.97826443569554,
        top: 154.99409448818898,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "DxH23ufasL",
        width: 46.75188648293963,
        height: 46.75188648293963,
        left: 908.6879101049868,
        top: 447.12335958005247,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        opacity: 0.3,
      },
      {
        type: "shape",
        id: "jc7G-4o8Fj",
        width: 52.340141076115486,
        height: 52.340141076115486,
        left: 63.92642716535433,
        top: 311.9422572178478,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        opacity: 0.2,
      },
      {
        type: "shape",
        id: "v2OY7SMKQq",
        width: 30.236384514435695,
        height: 30.236384514435695,
        left: 74.97826443569554,
        top: 322.994094488189,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "xAyoVXspvE",
        width: 52.340141076115486,
        height: 52.340141076115486,
        left: 521.6804461942257,
        top: 143.94225721784775,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        opacity: 0.2,
      },
      {
        type: "shape",
        id: "dpe-eKyUpo",
        width: 30.236384514435695,
        height: 30.236384514435695,
        left: 532.7323654855643,
        top: 154.99409448818898,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Lh4fCOq2DE",
        width: 52.340141076115486,
        height: 52.340141076115486,
        left: 521.6804461942257,
        top: 311.9422572178478,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        opacity: 0.2,
      },
      {
        type: "shape",
        id: "um1PevPjA7",
        width: 30.236384514435695,
        height: 30.236384514435695,
        left: 532.7323654855643,
        top: 322.994094488189,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "FPqvyqW11O",
        width: 320.3603182414698,
        height: 150.875,
        left: 129.17544291338584,
        top: 143.94225721784775,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 14.0625px;font-family: Microsoft Yahei;">${node.children[0].title || ""
          }${node.children[0].title ? "：" : ""}${node.children[0].text
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "text",
        id: "dh7HuhGnYH",
        width: 320.3603182414698,
        height: 150.875,
        left: 129.17544291338584,
        top: 311.9422572178478,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 14.0625px;font-family: Microsoft Yahei;">${node.children[1].title || ""
          }${node.children[1].title ? "：" : ""}${node.children[1].text
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "text",
        id: "si0iw3SYbY",
        width: 320.3603182414698,
        height: 150.875,
        left: 600.1139271653543,
        top: 311.9422572178478,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 14.0625px;font-family: Microsoft Yahei;">${node.children[2].title || ""
          }${node.children[2].title ? "：" : ""}${node.children[2].text
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "text",
        id: "6V_5e-Au2A",
        width: 320.3603182414698,
        height: 150.875,
        left: 600.1139271653543,
        top: 143.94225721784775,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 14.0625px;font-family: Microsoft Yahei;">${node.children[3].title || ""
          }${node.children[3].title ? "：" : ""}${node.children[3].text
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "shape",
        id: "7NwiYtmhmC",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 29.14288057742782,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "cAElZmIctL",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 28.90100065616798,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "ATHuSCs2HO",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 29.041748687664043,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "8x5aGzJzae",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 29.777477034120736,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "HqEDomTgMw",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 29.438484251968504,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "ZcMLYIns-9",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 38.80282152230971,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "QYgc4JnwIC",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 38.560859580052494,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "i6P3PUsV8e",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 38.70168963254593,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "u7XUSZp5Ns",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 39.437417979002625,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "NoArFS6j3z",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 39.09842519685039,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "SpytixBBVj",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 48.4627624671916,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "G5RimodwzF",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 48.22080052493438,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "B4bawj6TuF",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 48.36154855643044,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "ixK5yP2Nyq",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 49.09727690288714,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "pR5V__iFhg",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 48.758284120734906,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "CnOWEAqNEy",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 58.122621391076116,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "ZOPHIKCehx",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 57.88074146981627,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "M162c14vWn",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 58.02148950131234,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "a4K7Sgo0dT",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 58.75721784776903,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "wuUuC2wz3p",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 58.418225065616795,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "dOK9sOsKbD",
        width: 820.500997375328,
        height: 57.5,
        left: 89.74950131233598,
        top: 29.14288713910761,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 25px;"><span style="font-family: Microsoft Yahei;">${node.title || ""
          }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "line",
        id: "OuuwAFF_Rt",
        width: 0.75,
        left: 90.09645669291338,
        top: 196.28239829396324,
        start: [0, 0],
        end: [0, 71.56725721784777],
        style: "dashed",
        color: `${color}`,
        points: ["", ""],
      },
      {
        type: "line",
        id: "rlgOanoSrk",
        width: 0.75,
        left: 90.09645669291338,
        top: 364.28239829396324,
        start: [0, 0],
        end: [0, 71.56725721784777],
        style: "dashed",
        color: `${color}`,
        points: ["", ""],
      },
      {
        type: "line",
        id: "BqmQlngNmG",
        width: 0.75,
        left: 547.8504757217847,
        top: 196.28239829396324,
        start: [0, 0],
        end: [0, 71.56725721784777],
        style: "dashed",
        color: `${color}`,
        points: ["", ""],
      },
      {
        type: "line",
        id: "xV0hy6LF3J",
        width: 0.75,
        left: 547.8504757217847,
        top: 364.28239829396324,
        start: [0, 0],
        end: [0, 71.56725721784777],
        style: "dashed",
        color: `${color}`,
        points: ["", ""],
      },
    ],
    background
  };
};

export default nodule;
